<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M4,6C4,6,5,6,5,6C5,6,5,5,5,5C5,5,4,5,4,5C4,5,4,6,4,6C4,6,4,6,4,6ZM13,9C13,8.72,12.89,8.47,12.71,8.29C12.71,8.29,9.71,5.29,9.71,5.29C9.53,5.11,9.28,5,9,5C8.72,5,8.47,5.11,8.29,5.29C8.29,5.29,5.29,8.29,5.29,8.29C5.11,8.47,5,8.72,5,9C5,9.55,5.45,10,6,10C6.28,10,6.53,9.89,6.71,9.71C6.71,9.71,8,8.41,8,8.41C8,8.41,8,15,8,15C8,15.55,8.45,16,9,16C9.55,16,10,15.55,10,15C10,15,10,8.41,10,8.41C10,8.41,11.29,9.7,11.29,9.7C11.47,9.89,11.72,10,12,10C12.55,10,13,9.55,13,9C13,9,13,9,13,9ZM5,3C5,3,4,3,4,3C4,3,4,4,4,4C4,4,5,4,5,4C5,4,5,3,5,3C5,3,5,3,5,3ZM15,0C15,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,14,0,14C0,14.55,0.45,15,1,15C1,15,6,15,6,15C6,15,6,13,6,13C6,13,2,13,2,13C2,13,2,12,2,12C2,12,6,12,6,12C6,12,6,11,6,11C6,11,3,11,3,11C3,11,3,2,3,2C3,2,14,2,14,2C14,2,14,11,14,11C14,11,12,11,12,11C12,11,12,12,12,12C12,12,14,12,14,12C14,12,14,13,14,13C14,13,12,13,12,13C12,13,12,15,12,15C12,15,15,15,15,15C15.55,15,16,14.55,16,14C16,14,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'GitPush',
} as DefineComponent
</script>
